export function getStartDateRule(formData) {
    return [
        {
            type: 'date',
            message: '資料格式不符',
            trigger: 'blur',
        },
        {
            validator: (rule, value, callback) => {
                if (formData.endDate && value > formData.endDate) {
                    callback(new Error('起始日期須早於結束日期'))
                } else {
                    callback()
                }
            },
            trigger: 'submit',
        },
    ]
}
export function getEndDateRule(formData) {
    return [
        {
            type: 'date',
            message: '資料格式不符',
            trigger: 'blur',
        },
        {
            validator: (rule, value, callback) => {
                if (formData.startDate && value < formData.endDate) {
                    callback(new Error('結束日期須晚於起始日期'))
                } else {
                    callback()
                }
            },
            trigger: 'submit',
        },
    ]
}
